/*
 * @Author: KK
 * @Date: 2022-12-04
 * @LastEditors: KK
 * @LastEditTime: 2022-12-04
 * @tip:
 *      必传参数 leftTimestamp（时间戳）
 *      可选参数 slot（插槽）接收参数（{langtxt, daytxt, day, hour, mi, se}）
 */

import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
    this.goTime(props.leftTimestamp)
  }
  goTime = (t) => {
    this.countDown(t)
  }
  state = {
    time: 0,
    day: 0,
    hour: 0,
    mi: 0,
    se: 0
  }
  async componentWillMount() {
    await this.RunOnStart()
  }

  async RunOnStart() {}

  componentWillReceiveProps(e) {
    // 获取倒计时时间戳
    if (this.state.time == 0) {
      let { leftTimestamp } = e
      this.countDown(leftTimestamp)
    }
  }

  // 倒计时函数，计算
  countDown = (times) => {
    var timer = null
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          daystr = day
        } else if (day <= 0) {
          daystr = '00'
        }
        this.setState({
          day: daystr,
          hour: hour,
          mi: minute,
          se: second,
          time: daystr + hour + ':' + minute + ':' + second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  render() {
    let { slot, lang, language } = this.props
    let { day, hour, mi, se } = this.state

    /**
     * 倒计时文本
     * @returns {string} 不同语言倒计时文本
     */
    let langTxt = () => {
      switch (language) {
        case 'ar':
          return 'العد التنازلي'
        case 'tr':
          return 'Kalan Süre'
        default:
          return 'CountDown'
      }
    }
    /**
     * 单数复数的天数文本
     * @returns {string} 天数文本
     */
    let dayTxt = () => {
      switch (language) {
        case 'ar':
          return "يوم"
        case 'tr':
          return 'Gün'
        default:
          return 'Days'
      }
    }

    return (
      <div className="app-countdown">
        {/* 默认时间格式 */}
        {slot == undefined && (
          <div className="app-cd-timer">
            <div className="app-cd-langtxt">{langTxt()}:</div>
            <div className="app-cd-day">{day}</div>
            <div className="app-cd-daytxt">{dayTxt()}</div>
            <div className="app-cd-h">{hour}</div>
            <div className="app-cd-colon">:</div>
            <div className="app-cd-m">{mi}</div>
            <div className="app-cd-colon">:</div>
            <div className="app-cd-s">{se}</div>
          </div>
        )}
        {/* 插槽 */}
        {slot != undefined && slot({ langtxt: langTxt(), daytxt: dayTxt(), day, hour, mi, se })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/CountDown/index.js